import {getApp, getApps, initializeApp} from "firebase/app"
import {initializeFirestore, connectFirestoreEmulator} from "firebase/firestore"
import {getFunctions, connectFunctionsEmulator} from "firebase/functions"
import {getStorage, connectStorageEmulator} from "firebase/storage"
import {getAuth, connectAuthEmulator} from "firebase/auth"
import {getAnalytics, isSupported as isSupportedAnalytics} from "firebase/analytics"
import {getMessaging, isSupported as isSupportedMessaging} from "firebase/messaging"

const useEmulator = import.meta.env.VITE_USE_EMULATOR === "true" || false

// config
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
}

const firestoreConfig = {
  ignoreUndefinedProperties: true,
  // experimentalAutoDetectLongPolling: true,
  // experimentalForceLongPolling: true,
  merge: true,
}

// init
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp()
const firestore = initializeFirestore(app, firestoreConfig)
const functions = getFunctions(app, "europe-west1")
const storage = getStorage(app)
const auth = getAuth(app)
const analytics = useEmulator ? false : isSupportedAnalytics() ? getAnalytics(app) : false
const messaging = isSupportedMessaging() ? getMessaging(app) : false

// emulator
if (import.meta.env.VITE_ENVIRONMENT == "local_dev" && useEmulator) {
  console.log("using emulator: functions, firestore, storage, auth")
  connectFirestoreEmulator(firestore, "127.0.0.1", 8080)
  connectFunctionsEmulator(functions, "127.0.0.1", 5001)
  connectStorageEmulator(storage, "127.0.0.1", 9199)
  connectAuthEmulator(auth, "http://127.0.0.1:9099/", {
    disableWarnings: true,
  })
}

export {firestore, functions, auth, analytics, storage, messaging}
